import { GET_CURRENT_USER } from '@/Graphql/queries';
import { getRoutes } from '@/routes/routePaths';
import { Role } from '@/Types/gql/graphql';
import { authState } from '@/vars/auth';
import { useLazyQuery } from '@apollo/client';
import { useLocation, useNavigate } from 'react-router-dom';

export const useGetCurrentUser = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [getCurrentUser] = useLazyQuery(GET_CURRENT_USER, {
    onCompleted: async (res) => {
      const user = res?.getCurrentUser;
      authState({
        authenticated: true,
        loading: false,
        userDetails: user,
      });
      if (res?.getCurrentUser?.role && res.getCurrentUser.firstName && res.getCurrentUser.email) {
        if (res?.getCurrentUser?.role == Role.Coach || res?.getCurrentUser?.role == Role.Trainer) {
          navigate(getRoutes.Sessions);
        } else if (res?.getCurrentUser?.role == Role.Trainee) {
          navigate(getRoutes.home);
        } else {
          const queryParams = new URLSearchParams(location.search);
          const redirectUrl = queryParams.get('redirect');
          if (redirectUrl) {
            navigate(redirectUrl);
          } else {
            navigate(getRoutes.home);
          }
        }
      } else {
        navigate(`${getRoutes.SignUp}${location.search}`);
      }
    },
    fetchPolicy: 'no-cache',
  });
  return { getCurrentUser };
};
